<template>
  <div data-cy="referral-page" class="referral-page">
    <Header />
    <Benefits />
    <About />
    <Services />
    <Footer />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Header from "./components/Header";
import Benefits from "./components/Benefits/index";
import About from "./components/About/index";
import Services from "./components/Services/index";
import Footer from "./components/Footer";

export default {
  name: "Referral",

  components: {
    Header,
    Benefits,
    About,
    Services,
    Footer,
  },

  async created() {
    const viewedKey = "is_view_ref";
    const currentAgent = this.$route.query.agent;

    if (!currentAgent) return;

    const storedAgent = localStorage.getItem(viewedKey);

    if (storedAgent !== currentAgent) {
      try {
        await this.saveView({ agentHash: currentAgent });
        localStorage.setItem(viewedKey, currentAgent);
      } catch (_) {
        // ignore view count errors
      }
    }
  },

  methods: {
    ...mapActions("publicReferral", ["saveView"]),
  },
};
</script>
